export default "__VITE_ASSET__CE05Unhd__"